export default __webpack_public_path__ + "static/reverie_Debussy-eded79aa80ee695f69881472c7ca196b.mp3";